<template>
  <div class="clientes-search-list">
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="4"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="vendedores" 
            :fields="fields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarVendedor">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'VendedoresSearchList',
  data: () => {
    return {
      vendedores: [],
      fields: [
        {
          key: 'nombre',
          label: 'Vendedor',
          sortable: true
        }
      ],

      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getVendedores();
  },  
  methods: {
    getVendedores() {
      this.tableBusy = true;
      this.$store.dispatch('vendedores/getList')
        .then(() => {
          this.vendedores = this.$store.getters['vendedores/list'];
          this.totalRegistros = this.vendedores.length;
          this.tableBusy = false;
        })
    },
    seleccionarVendedor (item) {
      this.$emit('vendedorSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
  .clientes-search-list .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .clientes-search-list .registro table td[aria-colindex="2"],
  .clientes-search-list .registro table td[aria-colindex="3"] {
    width: 45%;
  }
</style>
